import React from 'react';
import { useForm } from 'react-hook-form';
import { Form, Button } from 'react-bootstrap';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  const onSubmit = async (data) => {

    const payload = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      message: data.message
    };

    try {
      // const response = await fetch("http://192.168.0.7:8001/send-enquiry/", {
      const response = await fetch("https://api.sifgroup.org/send-enquiry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const text = await response.text();

      const result = JSON.parse(text);

      if (response.ok) {
        alert("Thank you! Your enquiry has been sent successfully.");
        reset();
      } else {
        alert(result.message || "Failed to send enquiry.");
      }

    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="p-4 bg-white rounded shadow-sm">

      <h3 className="mb-4">Get in Touch</h3>

      <Form.Group className="mb-3">
        <Form.Label>Full Name</Form.Label>
        <Form.Control
          type="text"
          {...register("name", { required: "Name is required" })}
          className={errors.name ? 'is-invalid' : ''}
        />
        {errors.name && <Form.Text className="text-danger">{errors.name.message}</Form.Text>}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Email Address</Form.Label>
        <Form.Control
          type="email"
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address"
            }
          })}
          className={errors.email ? 'is-invalid' : ''}
        />
        {errors.email && <Form.Text className="text-danger">{errors.email.message}</Form.Text>}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control
          type="tel"
          {...register("phone")}
        />
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label>Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          {...register("message", {
            required: "Message is required",
            minLength: {
              value: 10,
              message: "Message must be at least 10 characters"
            }
          })}
          className={errors.message ? 'is-invalid' : ''}
        />
        {errors.message && <Form.Text className="text-danger">{errors.message.message}</Form.Text>}
      </Form.Group>

      <Button type="submit" className="btn-gold-filled w-100">
        Send Message
      </Button>

    </Form>
  );
};

export default ContactForm;